import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.haveExpectedFeatures)
    ? _renderSlot(_ctx.$slots, "default", { key: 0 })
    : _renderSlot(_ctx.$slots, "not-allowed", { key: 1 })
}